export function loginReducer(state, action) {
  switch (action.type) {
    case 'SET_TENANT':
      return {
        ...state,
        tenant: action.data,
      }
    case 'SET_USER_INFO':
      return {
        ...state,
        user: action.user,
        role: action.role,
        permissions: action.permissions,
      }
    case 'accessToken':
      return {
        ...state,
        accessToken: action.data,
      }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}
